import { createContext, useContext } from "react";
import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";

export type QueryBuilderContextType = {
  builder: QueryBuilder<Record<string, string> | undefined>;
};

export const QueryBuilderContext = createContext<QueryBuilderContextType | undefined>(undefined);

export const useQueryBuilderContext = () => {
  const context = useContext(QueryBuilderContext);

  if (context === undefined) {
    throw new Error("useQueryBuilderContext must be used within a QueryBuilderProvider");
  }

  return context;
};
